import { OnInit, Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ValidatorService } from 'app/shared/services/validator.service';
import { IResult } from 'app/shared/models/result.model';
import { Subject, Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { OrganizationService } from 'app/views/appviews/organization/organization.service';
import { IDtoCustomer } from 'app/shared/models/customer/dto-customer.model';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { CustomerService } from 'app/views/appviews/quote/customer.service';
import { PositionService } from 'app/views/appviews/quote/position.service';
import { IDtoMinimumSalary } from 'app/shared/models/position/dto-minimum-salary.model';
import { IDtoRiskPremium } from 'app/shared/models/organization/dto-risk-premium.model';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { IDtoDocument } from 'app/shared/models/request/dto-document.model';
import { DatePipe } from '@angular/common';
import { DocumentService } from 'app/shared/services/document.service';
import { saveAs } from 'file-saver';
@Component({
    selector: 'app-modal-customer',
    styleUrls: ['./modal-customer.style.scss'],
    templateUrl: './modal-customer.template.html',
    encapsulation: ViewEncapsulation.None
})

export class ModalCustomerComponet implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private formCustomer: FormGroup;
    /**Variable de trasporte de datos */
    private result: IResult;
    /**Retorno a pantalla padre */
    public onClose: Subject<any>;
    /**Variables */
    private customer = {} as IDtoCustomer;
    private action: string;
    private minimumSalary = {} as IDtoMinimumSalary;
    private riskPremium = {} as IDtoRiskPremium;
    /**Catalogos */
    private catalogCompanies: Observable<IDtoCatalog[]>;
    private catalogCustomerTypes: Observable<IDtoCatalog[]>;
    private catalogPaymentTerms: Observable<IDtoCatalog[]>;
    private files: FileList;
    private fileName = '';
    private document = {} as IDtoDocument;
    constructor(private bsModalRef: BsModalRef
        , private formBuilder: FormBuilder
        , private organizationService: OrganizationService
        , private customerService: CustomerService
        , private configGeneral: AppConfig
        , private positionService: PositionService
        , private identityService: IdentityService
        , private spinner: NgxSpinnerService
        , private datePipe: DatePipe
        , private documentService: DocumentService) {
        this.initializeFormRiskPremium();
    }
    ngOnInit(): void {
        this.catalogCompanies = this.organizationService.getCatalogCompanies();
        this.catalogCustomerTypes = this.organizationService.getCatalogCustomerTypes();
        this.catalogPaymentTerms = this.organizationService.getCatalogPaymentTerms();
        this.getMinimumSalary();
        this.onClose = new Subject();
        if (this.action === 'edit') {
            let contractExpirationDate = this.configGeneral.setDate(this.customer.contractExpirationDate);
            this.formCustomer.patchValue(this.customer);
            this.formCustomer.get('contractExpirationDate').setValue(contractExpirationDate);
            this.getLatesDocumentVersion();
        }
    }
    private getMinimumSalary(): void {
        this.positionService.getMinimumSalary().subscribe(res => {
            this.minimumSalary = res.data as IDtoMinimumSalary;
            if (this.action === 'add') {
                this.formCustomer.get('minimumSalary').setValue(this.minimumSalary.value);
            }
        })
    }
    private getLatesDocumentVersion(): void {
        this.documentService.getLatesDocumentVersion(this.customer.id, 'ContratoCliente').subscribe(res => {
            this.document = res.data as IDtoDocument;
            this.fileName = this.document.fileName;
        })
    }
    private getRiskPremiumByCompanyId(companyId: number): void {
        this.organizationService.getRiskPremiumByCompanyId(companyId).subscribe(res => {
            if (res.data == null) {
                this.configGeneral.newToast('Validación', 'No existe una prima de riesgo activa para esta compañia', 'warning');
            } else {
                this.riskPremium = res.data as IDtoRiskPremium;
                this.formCustomer.get('riskPremiumValue').setValue(this.riskPremium.value);
            }
        })
    }
    private initializeFormRiskPremium() {
        this.formCustomer = this.formBuilder.group({
            codeNom: [null, []],
            rfc: [null, [Validators.required, Validators.maxLength(13)]],
            name: [null, [Validators.required, Validators.maxLength(150)]],
            shortName:[null, [Validators.required, Validators.maxLength(100)]],
            billCompanyId: [null, [Validators.required]],
            payCompanyId: [null, [Validators.required]],
            customerTypeId: [null, [Validators.required]],
            paymentTermId: [null, [Validators.required]],
            agencyPercentage: [null, [Validators.required]],
            expensesPercentage: [null, [Validators.required]],
            administrativeExpensesPercentage: [null, [Validators.required]],
            creditDays: [null, [Validators.required]],
            minimumSalary: [null, [Validators.required]],
            riskPremiumValue: [null, [Validators.required]],
            staffType: [null, [Validators.required]],
            contractExpirationDate: [null],
            legalResponsibleName: [null, [Validators.required, Validators.maxLength(200)]],
            legalResponsibleEmail: [null, [Validators.required, Validators.email, Validators.maxLength(100)]]
        });
    }
    private submit(): void {
        if (this.formCustomer.valid) {
            if (this.action === 'add') {
                this.save();
            } else {
                this.update();
            }
        } else {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
            this.configGeneral.touchedControls(this.formCustomer);
        }
    }
    private save(): void {
        const dto = this.formCustomer.value as IDtoCustomer;
        if (this.formCustomer.value.contractExpirationDate != null) {
            dto.contractExpirationDate = this.configGeneral.getLocalISOTime(this.configGeneral.getDate(this.formCustomer.value.contractExpirationDate));
        }
        this.customerService.addCustomer(dto)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        let c = x.data as IDtoCustomer;
                        this.addModuleLog(c.id, 'new');
                        this.onClose.next(c);
                        this.bsModalRef.hide();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private update(): void {
        const dto = this.formCustomer.value as IDtoCustomer;
        dto.id = this.customer.id;
        if (this.formCustomer.value.contractExpirationDate != null) {
            dto.contractExpirationDate = this.configGeneral.getLocalISOTime(this.configGeneral.getDate(this.formCustomer.value.contractExpirationDate));
        }
        this.customerService.updateCustomer(dto)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        if (this.customer.minimumSalary != +dto.minimumSalary || this.customer.riskPremiumValue != +dto.riskPremiumValue) {
                            this.updatePositionMasiveByCustomer(dto.minimumSalary, dto.riskPremiumValue);
                        }
                        this.addModuleLog(dto.id, 'update');
                        this.onClose.next(dto);
                        this.bsModalRef.hide();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private onCancel(): void {
        this.bsModalRef.hide();
    }
    private updatePositionMasiveByCustomer(uma: number, riskPremiumValue: number): void {
        const dto = {} as IDtoCatalog;
        dto.id = this.customer.id;
        dto.name = `${uma}|${riskPremiumValue}`;
        this.positionService.updatePositionMasiveByCustomer(dto)
            .subscribe(
                (x) => {
                    if (x.isCorrect == false) {
                        this.configGeneral.newToast('Error', 'La actualización de puestos no pudo ser completada', 'error');
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private addModuleLog(id: number, action: string): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'Customers';
        dto.module = 'customers';
        dto.action = action;
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
    private onFileChange(event) {
        event.value = '';
    }
    private handleFileInput(files: FileList) {
        //this.fileName = files.item(0).name;
        this.upload(files);
    }
    private upload(files: FileList): void {
        if (files != undefined) {
            this.spinner.show();
            let document = {} as IDtoDocument;
            const fileName = files.item(0).name;
            let sp = fileName.split('.').pop();
            let fileNameNew = `${this.customer.id}_Contrato_${this.datePipe.transform(new Date(), 'ddMMyyyy')}.${sp}`;
            document.fileName = fileNameNew;
            this.fileName = fileNameNew;
            document.referenceId = this.customer.id;
            document.folder = 'CustomerContracts';
            document.module = 'Customers';
            document.name = "ContratoCliente";
            document.acceptDuplicate = true;
            const file = files.item(0);
            this.documentService.addDocument(document, file).subscribe((res) => {
                if (res.isCorrect === true) {
                    this.configGeneral.newToast('Éxito', res.message, 'success');
                    this.document = res.data as IDtoDocument;
                    this.fileName = this.document.fileName;
                    this.addModuleLog(this.customer.id, 'addContract');
                } else {
                    this.configGeneral.newToast('Error', res.message, 'error');
                }
                this.spinner.hide();
            },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
        }
    }
    private downloadFile(): void {
        this.documentService.downloadFile(this.document.id).subscribe((res) => {
            if (res.isCorrect === true) {
                const file = res.data as any;
                const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
                saveAs(blob, file.fileDownloadName);
                this.addModuleLog(this.document.id, 'downloadFile');
                this.spinner.hide();
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
                this.spinner.hide();
            }
        },
        (errMessage) => {
            this.spinner.hide();
            this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
        });
    }
}
